import { Component, Input, ViewChild, ComponentFactoryResolver, ChangeDetectorRef, OnChanges } from '@angular/core'

import { Question, QUESTION_TYPES_ID_MAPPING, QUESTION_CONTEXT_TYPES_ID_MAPPING } from '../../../../data/models'
import { Form } from '../../../../forms/models'

import {
  DefaultQuestionContextViewComponent,
  QuestionContextHost,
  SentenceSelectQuestionContextViewComponent,
  EnhancedTabularQuestionContextComponent,
  IQuestionContextView,
  TabbedQuestionContextViewComponent
} from '.'

@Component({
  selector: 'mp-question-context-view',
  templateUrl: './question-context-view.html'
})
export class QuestionContextViewComponent implements OnChanges {

  @Input() public question: Question
  @Input() public form: Form<Question>

  @ViewChild(QuestionContextHost)
  public questionContextHost: QuestionContextHost

  public get questionContext() {
    return this.question.questionContext
  }

  private _questionContextByQuestionTypeMap = {}
  private _questionContextByTypeMap = {}

  public constructor(
    private _componentFactoryResolver: ComponentFactoryResolver,
    private _changeDetector: ChangeDetectorRef
  ) {


    this._questionContextByQuestionTypeMap[QUESTION_TYPES_ID_MAPPING.SENTENCE_SELECT] = SentenceSelectQuestionContextViewComponent
    this._questionContextByTypeMap[QUESTION_CONTEXT_TYPES_ID_MAPPING.TABBED] = TabbedQuestionContextViewComponent
    this._questionContextByTypeMap[QUESTION_CONTEXT_TYPES_ID_MAPPING.TABULAR] = EnhancedTabularQuestionContextComponent
  }

  public ngOnChanges() {
    if (this.questionContextHost) {
      this._loadContextView()
    }
  }

  private _getContextComponentByQuestion() {
    return this._questionContextByQuestionTypeMap[this.question.questionType.id] ||
      this._questionContextByTypeMap[this.question.questionContext.questionContextType.id] ||
      DefaultQuestionContextViewComponent
  }

  private _loadContextView() {
    const componentClass = this._getContextComponentByQuestion()
    const componentFactory = this._componentFactoryResolver.resolveComponentFactory<IQuestionContextView>(componentClass)
    const viewContainerRef = this.questionContextHost.viewContainerRef

    viewContainerRef.clear()

    const questionContextViewComponent = viewContainerRef.createComponent<IQuestionContextView>(componentFactory).instance
    questionContextViewComponent.question = this.question
    questionContextViewComponent.form = this.form
    this._changeDetector.detectChanges()
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/question-view/question-context-view/question-context-view.component.ts